import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import "../Menu.css";
import { register } from "../redux/actions/authAction";
import Footer from "./footer";
import Navbar from "./navbar";

const ERROR_STYLE = { color: "red", margin: 0, fontSize: "14px" };
const LENGTH_OF_TEXT = 200;

const Register = () => {
	const dispatch = useDispatch();

	const initialState = {
		fullname: "",
		username: "",
		email: "",
		password: "",
		cf_password: "",
		mobile: "",
	};
	const [userData, setUserData] = useState(initialState);
	const [errors, setErrors] = useState({});
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	const handleChangeInput = (e) => {
		const { name, value } = e.target;
		setUserData({ ...userData, [name]: value });
	};

	const handlePhoneChange = (value) => {
		setUserData({ ...userData, mobile: value });
	};

	const validateForm = () => {
		const newErrors = {};
		if (!userData.fullname) newErrors.fullname = "Full name is required.";
		if (!userData.email) newErrors.email = "Email is required.";
		else if (!/\S+@\S+\.\S+/.test(userData.email))
			newErrors.email = "Email is invalid.";
		if (!userData.mobile) newErrors.mobile = "Mobile number is required.";
		if (!userData.password) newErrors.password = "Password is required.";
		else if (
			!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/.test(
				userData.password
			)
		) {
			newErrors.password =
				"Password should contain at least one uppercase, lowercase, number, special character, and be at least 8 characters long.";
		}
		if (!userData.cf_password)
			newErrors.cf_password = "Confirm password is required.";
		if (
			userData.password &&
			userData.cf_password &&
			userData.password !== userData.cf_password
		)
			newErrors.cf_password = "Passwords do not match.";
		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (!validateForm()) return;
		dispatch(register(userData));
	};

	return (
		<>
			<Navbar />
			<div id="testlogin" style={{ backgroundColor: "white" }}>
				<div className="spacer"></div>
				<div className="row">
					<div className="col-1"></div>
					<div className="col-10 blockj">
						<h1 className="heading">Account Information</h1>
						<form onSubmit={handleSubmit} autoComplete="off">
							<label className="email-label-2">
								Full name <span style={{ color: "rgb(114, 28, 36)" }}>*</span>
							</label>
							<div className="email-input">
								<input
									className="email-input"
									maxLength={LENGTH_OF_TEXT}
									value={userData.fullname}
									type="text"
									required
									name="fullname"
									onChange={handleChangeInput}
								/>
							</div>
							<p
								style={{
									...ERROR_STYLE,
									visibility: errors.fullname ? "visible" : "hidden",
								}}
								className="error-message ms-3">
								{errors.fullname}
							</p>
							<div className="row">
								<div className="col-sm-12 col-md-12 col-lg-6">
									<div
										style={{
											display: "flex",
											justifyContent: "space-between",
										}}>
										<label className="email-label-2">
											Password{" "}
											<span style={{ color: "rgb(114, 28, 36)" }}>*</span>
										</label>
										<span
											className="toggle-password d-flex align-items-center"
											onClick={() => setShowPassword(!showPassword)}>
											{showPassword ? (
												<div style={{ cursor: "pointer" }}>
													<FaEyeSlash className="me-1" />
													Hide Password
												</div>
											) : (
												<div style={{ cursor: "pointer" }}>
													<FaEye className="me-1" />
													Show Password
												</div>
											)}
										</span>
									</div>
									<div className="password-input">
										<input
											className="password-input"
											type={showPassword ? "text" : "password"}
											value={userData.password}
											maxLength={LENGTH_OF_TEXT}
											autoComplete="off"
											name="password"
											onChange={handleChangeInput}
											required
										/>
									</div>
									<p
										className="error-message ms-3"
										style={{
											...ERROR_STYLE,
											visibility: errors.password ? "visible" : "hidden",
										}}>
										{errors.password}
									</p>
								</div>
								<div className="col-sm-12 col-md-12 col-lg-6">
									<div
										style={{
											display: "flex",
											justifyContent: "space-between",
										}}>
										<label className="email-label-2">
											Confirm Password{" "}
											<span style={{ color: "rgb(114, 28, 36)" }}>*</span>
										</label>
										<span
											className="toggle-password d-flex align-items-center"
											onClick={() =>
												setShowConfirmPassword(!showConfirmPassword)
											}>
											{showConfirmPassword ? (
												<div style={{ cursor: "pointer" }}>
													<FaEyeSlash className="me-1" />
													Hide Password
												</div>
											) : (
												<div style={{ cursor: "pointer" }}>
													<FaEye className="me-1" />
													Show Password
												</div>
											)}
										</span>
									</div>
									<div className="email-input">
										<input
											className="password-input"
											type={showConfirmPassword ? "text" : "password"}
											maxLength={LENGTH_OF_TEXT}
											value={userData.cf_password}
											autoComplete="off"
											name="cf_password"
											onChange={handleChangeInput}
											required
										/>
									</div>
									<p
										className="error-message ms-3"
										style={{
											...ERROR_STYLE,
											visibility: errors.cf_password ? "visible" : "hidden",
										}}>
										{errors.cf_password}
									</p>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-12 col-md-12 col-lg-6">
									<label className="email-label-2">
										Email Address{" "}
										<span style={{ color: "rgb(114, 28, 36)" }}>*</span>
									</label>
									<div className="email-input">
										<input
											className="email-input"
											maxLength={LENGTH_OF_TEXT}
											type="email"
											name="email"
											onChange={handleChangeInput}
											value={userData.email}
										/>
									</div>
									<p
										className="error-message ms-3"
										style={{
											...ERROR_STYLE,
											visibility: errors.email ? "visible" : "hidden",
										}}>
										{errors.email}
									</p>
								</div>
								<div className="col-sm-12 col-md-12 col-lg-6">
									<label className="email-label-2">
										Mobile number{" "}
										<span style={{ color: "rgb(114, 28, 36)" }}>*</span>
									</label>
									<div className="email-input">
										<PhoneInput
											country={"in"}
											value={userData.mobile}
											onChange={handlePhoneChange}
											inputStyle={{
												width: "100%",
												height: "50px",
												padding: "12px",
												borderColor: "rgb(119, 119, 119)",
												fontFamily: "Rubik, sans-serif",
												fontSize: "16px",
												borderRadius: "8px",
												marginBottom: "25px",
												borderWidth: "0.7px",
											}}
										/>
									</div>
									<p
										className="error-message ms-3"
										style={{
											...ERROR_STYLE,
											visibility: errors.mobile ? "visible" : "hidden",
										}}>
										{errors.mobile}
									</p>
								</div>
							</div>
							<button className="login-button mt-3" type="submit">
								Submit
							</button>
						</form>
						<div className="col-1"></div>
					</div>
					<div className="col-1"></div>
				</div>
				<div className="row">
					<div className="col-1"></div>
					<div className="col-10 text-left joinj">
						<div className="d-flex align-items-center">
							<span className="Already-button">Already have an account ?</span>
							<Link to="/login">
								<button className="A-Login-button fw-bolder" type="button">
									Login here
								</button>
							</Link>
						</div>
					</div>
					<div className="col-1"></div>
				</div>
				<div className="spacer"></div>
			</div>
			<Footer />
		</>
	);
};

export default Register;
